import type { FC, KeyboardEvent, MouseEvent } from 'react';
import styled, { css, useTheme } from 'styled-components';
import Icon, { IconName } from '../../icon/icon';
import { IconScale } from '../../icon/types';

interface ClearProps {
  handleClear: (event: MouseEvent | KeyboardEvent) => void;
}

const Clear: FC<ClearProps> = ({ handleClear }: ClearProps) => {
  const theme = useTheme();

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleClear(event);
    }
  };

  return (
    <ClearWrapper
      onMouseDown={handleClear}
      tabIndex={0}
      role="button"
      onKeyDown={handleKeyDown}
      aria-label="Clear content"
    >
      <Icon
        name={IconName.Close}
        scale={IconScale.S}
        color={theme.palette.primary.main}
        className="clear-icon"
      />
    </ClearWrapper>
  );
};

export default Clear;

const ClearWrapper = styled.div`
  ${({ theme }) => css`
    margin-right: ${theme.spacing(2)};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    width: ${theme.spacing(3)};
    height: ${theme.spacing(3)};
    min-width: ${theme.spacing(3)};
    min-height: ${theme.spacing(3)};
    max-width: ${theme.spacing(3)};
    max-height: ${theme.spacing(3)};
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      background-color: ${theme.palette.neutral[60]};
    }

    .clear-icon {
      line-height: ${theme.spacing(1.5)};
    }
  `}
`;
